// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.
import { Injectable } from '@angular/core';
import { SwUpdate } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({providedIn: 'root'})
export class AppUpdateService {
    private updateIsAvailable = new BehaviorSubject<boolean>(false);
    private excludePaths = ['login', 'subscriptions', 'invitation', 'cigent-invitation', 'd3e-invitation', 'd3e-news',
        'cigent-news', 'downloaded-free', 'd3e-download', 'download', 'reset', 'agent-download'];
    private includeExactPaths = ['downloads', 'subscriptions']; // includeExactPaths match overrides excludePaths startsWith match
    private immediateUpdatePaths = ['azureservice/activate'];
    constructor(public swUpdate: SwUpdate, private router: Router) {
    }

    public watchForUpdates(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.versionUpdates
              .subscribe(event => {
                  environment.__DEV__ && console.log(event.type);
                  if (event.type == 'VERSION_DETECTED') {
                      this.updateIsAvailable.next(true);

                      if (!this.isExcludedPath && this.isImmediateUpdatePath) {
                          this.swUpdate.activateUpdate().then(() => {
                              this.updateApp();
                          });
                      }
                  }
              });
        }
    }

    public updateApp(): void {
        this.updateIsAvailable.next(false);
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(registrations => {
                for (const registration of registrations) {
                    registration.unregister().then(success => {
                        if (success) {
                            console.log('Service worker unregistered successfully.');
                        } else {
                            console.log('Service worker unregistration failed.');
                        }
                    });
                }
                environment.__DEV__ && console.log('Reloading window...');
                window.location.reload();
            });
        } else {
            environment.__DEV__ && console.log('Reloading window (not unregistering service workers)...');
            window.location.reload();
        }
    }

    public showUpdateBanner(): boolean {
        return this.updateIsAvailable.value && !this.isExcludedPath;
    }

    public checkForUpdate(): void {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.checkForUpdate().then(() =>
                environment.__DEV__ && console.log('Check for app update completed.')
            );
        }
    }

    private get isExcludedPath(): boolean {
        const url = this.router.url.replace(/^\//, '');
        const foundExactIncludePath = this.includeExactPaths.some(path => path === url);
        const foundExcludedPath = this.excludePaths.some(path => url.startsWith(path));
        return foundExactIncludePath ? false : foundExcludedPath;
    }

    private get isImmediateUpdatePath(): boolean {
        const url = this.router.url.replace(/^\//, '');
        return this.immediateUpdatePaths.some(path => {
            return url.startsWith(path);
        });
    }
}
